import React from 'react';
import styles from './CartItem.module.scss';

const SimpleView = ({ additionalPoses = 0, sheetTypes = [] }) => {
  return (
    <ul className={styles.simpleView}>
      {sheetTypes.map((sheetType) => <li>{sheetType}</li>)}
      {additionalPoses > 0 && (
        <li>{`+ ${additionalPoses} additional poses`}</li>
      )}
    </ul>
  );
};

export default SimpleView;
